module.exports = __webpack_public_path__ + "media/images/log/log-weight-a4c839860fb948a02522e60ef475dc1c.svg";